import { User, MapPin, Phone, CreditCard, Truck, UserCheck, FileText } from 'lucide-react';

function Row({ icon: Icon, label, value }) {
  if (!value) return null;
  return (
    <div className="flex items-start gap-3 py-3 border-b border-border last:border-0">
      <div className="w-8 h-8 bg-muted rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
        <Icon className="w-4 h-4 text-muted-foreground" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs text-muted-foreground">{label}</p>
        <p className="text-sm font-medium text-foreground mt-0.5">{value}</p>
      </div>
    </div>
  );
}

export default function InfoTab({ order }) {
  const partner = order.partner_details;
  const customerName = partner?.name || (Array.isArray(order.partner_id) ? order.partner_id[1] : '—');
  const phone = partner?.phone || partner?.mobile;
  const address = partner ? [partner.street, partner.city].filter(Boolean).join('، ') : null;

  const salesperson = Array.isArray(order.user_id) ? order.user_id[1] : (order.user_id || null);
  const paymentTerm = Array.isArray(order.payment_term_id) ? order.payment_term_id[1] : (order.payment_term_id || null);
  const shippingAddress = Array.isArray(order.partner_shipping_id) ? order.partner_shipping_id[1] : (order.partner_shipping_id || null);
  const commitmentDate = order.commitment_date
    ? new Date(order.commitment_date).toLocaleDateString('ar-EG', { year: 'numeric', month: 'short', day: 'numeric' })
    : null;

  return (
    <div className="space-y-3">
      {/* Customer info */}
      <div className="bg-card border border-border rounded-2xl px-4">
        <p className="text-xs font-bold text-muted-foreground uppercase tracking-wider pt-3 pb-1">العميل</p>
        <Row icon={User} label="الاسم" value={customerName} />
        <Row icon={Phone} label="الهاتف" value={phone} />
        <Row icon={MapPin} label="العنوان" value={address} />
      </div>

      {/* Order info */}
      <div className="bg-card border border-border rounded-2xl px-4">
        <p className="text-xs font-bold text-muted-foreground uppercase tracking-wider pt-3 pb-1">معلومات الطلب</p>
        <Row icon={UserCheck} label="مندوب المبيعات" value={salesperson} />
        <Row icon={CreditCard} label="شروط الدفع" value={paymentTerm} />
        <Row icon={Truck} label="عنوان الشحن" value={shippingAddress !== customerName ? shippingAddress : null} />
        <Row icon={Truck} label="تاريخ التسليم المطلوب" value={commitmentDate} />
      </div>

      {/* Notes */}
      {order.note && (
        <div className="bg-card border border-border rounded-2xl px-4">
          <p className="text-xs font-bold text-muted-foreground uppercase tracking-wider pt-3 pb-1">ملاحظات داخلية</p>
          <div className="flex items-start gap-3 py-3">
            <div className="w-8 h-8 bg-muted rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
              <FileText className="w-4 h-4 text-muted-foreground" />
            </div>
            <p className="text-sm text-foreground leading-relaxed">{order.note}</p>
          </div>
        </div>
      )}
    </div>
  );
}